interface Env {
  companyName: string
  appName: string
}

export const env: Env = {
  companyName: import.meta.env.VITE_COMPANY_NAME || 'ACME Corporation',
  appName: import.meta.env.VITE_APP_NAME || 'Business Management System'
}